import React, { Fragment } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tooltip, Tag } from 'antd';
import { getVerificationTreeStatus } from '../../workflow/workflowHelper';
import {
  CHANNEL,
  SIMULATION,
  CHANNELS,
  ROCKY_PDN,
  MASK_DEFAULT,
  MASK_CUSTOMIZED,
  CARDS,
  CARD,
  CARD_VERIFICATION,
  CARD_CHANNEL,
  PACKAGE_CHANNEL,
  SSN_CHANNEL,
} from '../constants';
import {
  PCB_PRE_LAYOUT,
  LIBRARY,
  PROJECT,
  PROJECTS,
  PCB,
  PCBS,
  TRASH,
  RESULT,
  LIBRARY_DATA,
  LIBRARY_FILE,
  ADD,
  DELETE,
  UPLOAD_PCB,
  CLEAN,
  LOADING,
  MACRO_MODELING,
  STATUS,
  COPY,
  RENAME,
  MY_TRASH,
  DOWNLOAD,
  VERIFY,
  REPLACE_PCB,
  VERIFICATION,
  PACKAGES,
  PACKAGE,
  PACKAGE_VERIFICATION,
  UPDATE,
  SAVE,
  PACKAGE_PRE_LAYOUT,
  PACKAGE_PDN,
  PCB_PDN,
  PCB_CHANNEL,
  D2D_CHANNELS,
  INTERPOSERS,
  CARD_RESULT,
  COMBINE_INTERFACE,
  LIBRARY_OPEN,
  ADD_PROJECT,
  DEFAULT,
  SYS_LIBRARY_FILE,
  SYS_LIBRARY_FOLDER,
  EXPERIMENTS,
  PCB_SETTING,
  INTERPOSER,
  INTERPOSER_PRE_LAYOUT,
  D2D_CHANNEL,
  VERIFY_ALL,
} from '@/constants/treeConstants';
import {
  MICROSTRIP,
  STRIPLINE,
  PKG_TOUCHSTONE,
  CARD_LIBRARY,
  DECAP_SPICE,
  HFSS_OPTIONS,
  SIWAVE_OPTIONS,
  IBIS_AMI
} from '@/constants/libraryConstants';
import * as taskStatus from '@/constants/workflowStatus';
import { VERIFY_SUCCESS } from '@/constants/verificationStatus';
import { DESIGN_FAILED, DESIGN_IDENTIFY_FAILED } from '@/constants/designCategory';
import CreateItem from '../../../components/CreateItem';
import designConstructor from '../../helper/designConstructor';
import { PROJECT_V2 } from '../../../constants/projectVersion';

const CREATE_PACKAGE_CHANNEL_LOADING = "create-package-channel-loading";
const IconKey = {
  1: [ADD],
  2: [DELETE, REPLACE_PCB, PCB_SETTING],
  3: [UPLOAD_PCB],
  4: [CLEAN],
  5: [VERIFY, STATUS],
  6: [SIMULATION, VERIFY_ALL],
  7: [VERIFY],
  8: [DOWNLOAD, DELETE, MACRO_MODELING, RENAME, ADD, STATUS],
  9: [LOADING],
  10: [DELETE, COPY, RENAME],
  11: [/*DOWNLOAD*/],
  12: [/*DOWNLOAD,*/DELETE],
  13: [DOWNLOAD, DELETE, MACRO_MODELING, COPY],
  14: [STATUS, RENAME, DELETE],
  15: [ADD, DELETE],
  16: [UPLOAD_PCB, SIMULATION],
  17: [RENAME, ADD],
  18: [UPDATE],
  19: [SAVE, DELETE],
  20: [ADD_PROJECT],
  21: [DELETE, RENAME],
  22: [STATUS],
  23: [DOWNLOAD, DELETE, DEFAULT],
  24: [DEFAULT],
  25: [VERIFY, STATUS, DELETE],
  26: [COMBINE_INTERFACE, ADD, DELETE],
  27: [ADD, STATUS],
  0: []
};

function getIconKey(type, item, projectVersion) {
  switch (type) {
    case LIBRARY:
    case D2D_CHANNELS:
      // case PROJECTS:
      return 1;
    case PCB:
      return 2;
    case PCBS:
    case PACKAGES:
    case INTERPOSERS:
      return 3;
    case TRASH:
      return 4;
    case VERIFICATION:
    case CARD_VERIFICATION:
      return 5;
    case CHANNELS:
      return 6;
    case CHANNEL:
    case CARD_CHANNEL:
      /*   case SSN_CHANNEL: */
      // case PCB_CHANNEL:
      return 7;
    case LIBRARY_DATA:
      return 13;
    case LIBRARY_FILE:
      return item.fileType === DECAP_SPICE ? 23 : 8;
    case ROCKY_PDN:
    case CREATE_PACKAGE_CHANNEL_LOADING:
      return 9;
    case PROJECT:
      return 10;
    case MASK_DEFAULT:
      return 11;
    case MASK_CUSTOMIZED:
    case INTERPOSER:
      return 12;
    case PACKAGE_VERIFICATION:
      // return projectVersion === PROJECT_V2 ? 25 : 14;
      return 14
    case CARDS:
      return 16;
    case PACKAGE:
      return projectVersion === PROJECT_V2 ? 26 : 15;
    case PACKAGE_CHANNEL:
      return 17;
    case LIBRARY_OPEN:
      return 18;
    case CARD:
      return 19;
    case PROJECTS:
      return 20;
    case PACKAGE_PRE_LAYOUT:
    case PCB_PRE_LAYOUT:
    case D2D_CHANNEL:
    case EXPERIMENTS:
      return 21;
    case PACKAGE_PDN:
    case PCB_PDN:
    case PCB_CHANNEL:
      return 22;
    case SSN_CHANNEL:
      return 27;
    case SYS_LIBRARY_FILE:
      return item.parentId && item.parentId === "0" ? 24 : 0;
    case SYS_LIBRARY_FOLDER:
      return item.parentId && item.parentId === "-1" ? 24 : 0;
    default: return 0;
  }
}

function verificationTitle(item, getIcon) {
  const dataType = (!item.id && item.type === ROCKY_PDN) ? ROCKY_PDN : item.dataType;
  let className = "rocky-verification-tooltip";
  let loading = false;
  if (!item.id && item.type === ROCKY_PDN) {
    loading = true;
    className = "aurora-cursor-disabled";
  }
  const Keys = IconKey[getIconKey(dataType)];
  let { msg } = getVerificationTreeStatus(item.status, item.readyForSim, item);
  // !!! Can not delete the verification-${item.id} className, verification-item.id used for aurora-rocky-puppeteer - (verification-id), open byte setup page
  return <Tooltip
    placement="topLeft"
    title={loading ? <span>Loading PDN...</span> : <Fragment><span>{item.name}</span>{msg ? <span> · {msg}</span> : null}</Fragment>}
    className={`${className} channel-${item.channelId}-verification verification-${item.id}`}
    classNames={{ root: 'aurora-tooltip' }}
    mouseEnterDelay={0.8}
    mouseLeaveDelay={0}
  >
    <span
      id={item.id}
      className={item.type === ROCKY_PDN ? 'rocky-verification-name-span out-title-color' : "rocky-verification-name-span"}
        /* onDoubleClick={(e) => this.renameInterface(e, item)} */>{item.name}</span>
    <Fragment>{Keys.map((key, index) => { return getIcon(key, item) })}</Fragment>
  </Tooltip>
}

function outTitle(item, getIcon) {
  const Keys = IconKey[getIconKey(item.dataType, item)];
  return <span>
    <span className={`out-title-color ${item.key}`}>{item.name}</span>
    <Fragment>{Keys.map((key, index) => { return getIcon(key, item) })}</Fragment>
  </span>
}

function libraryTitle({ item,
  downloadProgress,
  downloadVisible,
  getIcon,
  libraryFileOperation,
  renameRender,
  renameInfo = {},
  defaultDecap
}) {
  let Keys = IconKey[getIconKey(item.dataType, item)];
  const fileType = item.fileType;
  if (fileType === CARD_LIBRARY && renameInfo && renameInfo.id === item.id) {
    return renameRender(item);
  }
  if (!item.deletable && [HFSS_OPTIONS, SIWAVE_OPTIONS].includes(item.fileType)) {
    Keys = Keys.filter(item => item !== DELETE)
  }
  const touchstoneClass = fileType === PKG_TOUCHSTONE && item.status !== taskStatus.SUCCEED ? "rocky-library-touchstone-file-span" : "";
  const decapSpiceClass = fileType === DECAP_SPICE ? " rocky-library-spice-file-span" : ""
  const name = fileType === MICROSTRIP || fileType === STRIPLINE ? `${item.name} - ${item.fileType.replace(fileType[0], fileType[0].toUpperCase())}` : item.name;
  const decapClass = defaultDecap && item.id === defaultDecap.libraryId ? " rocky-library-default-decap-title" : ""
  const amiWarningClass = fileType === IBIS_AMI && item.checkLossFiles && item.checkLossFiles.length ? " rocky-library-ami-warning-title" : ""
  return <span className={downloadVisible === item.id && !item.folderChildren ? downloadProgress === 100 ? 'download-progress-bar download-progress-bar-success' : 'download-progress-bar' : ""} style={{ "--percent": downloadProgress }}>
    <div className='tree-library-content'>
      <Tooltip
        key={item.key}
        placement="topLeft"
        mouseEnterDelay={0.8}
        mouseLeaveDelay={0}
        title={item.name}
        className={item.fileType === CARD_LIBRARY ? 'rocky-tooltip-span rocky-library-file-span rocky-card-library-span' : 'aurora-icon-color rocky-tooltip-span rocky-library-file-span ' + touchstoneClass + decapSpiceClass + decapClass + amiWarningClass}
        classNames={{ root: 'aurora-tooltip' }}
        onClick={(e) => libraryFileOperation(e, item)}
      >{name}
      </Tooltip>
      {defaultDecap && defaultDecap.libraryId && item.id === defaultDecap.libraryId ?
        <Tag color="#fff" className="rocky-decap-default">Default</Tag> : null}
      <Fragment>{Keys.map((key, index) => { return getIcon(key, item, index) })}</Fragment>
    </div>
  </span>
}

function maskTitle(item, getIcon, libraryFileOperation) {
  const Keys = IconKey[getIconKey(item.dataType)];
  return <span>
    <Tooltip
      key={item.key}
      placement="topLeft"
      mouseEnterDelay={0.8}
      mouseLeaveDelay={0}
      title={item.name}
      classNames={{ root: 'aurora-tooltip' }}
      className='rocky-tooltip-span'
      onClick={(e) => libraryFileOperation(e, item)}
    >{item.name}
    </Tooltip>
    <Fragment>{Keys.map((key, index) => { return getIcon(key, item) })}</Fragment>
  </span>
}

function defaultTitle(item, getIcon, renameInfo = {}, defaultDecap, projectVersion) {
  const Keys = IconKey[getIconKey(item.dataType, item, projectVersion)];
  if (item.dataType === RESULT) {
    return <span className='result-style'>{item.name}
      {item.status === VERIFY_SUCCESS && <Fragment>{Keys.map((key, index) => { return getIcon(key, item, index) })}</Fragment>}
    </span>
  }
  if ([PCB, PCB_PRE_LAYOUT, PACKAGE, PACKAGE_PRE_LAYOUT, CARD, INTERPOSER, INTERPOSER_PRE_LAYOUT].includes(item.dataType)) {
    const { renamePreLayoutInfo, renamePreLayout, cancelRename, projectId } = renameInfo;
    if (renamePreLayoutInfo && renamePreLayoutInfo.id && renamePreLayoutInfo.dataType === item.dataType && item.id === renamePreLayoutInfo.id) {
      const designList = designConstructor.getAvailableDesignsDesignValues(projectId) || []
      return <CreateItem
        itemData={item}
        createNodeId="rocky-check-project-icon"
        cancelNodeId="rocky-close-project-icon"
        createConfirm={(data) => renamePreLayout(data)}
        projectList={designList}
        cancelCreate={cancelRename}
      />
    }
    return (
      <span className={`rocky-${item.dataType}`}>
        <Tooltip
          key={item.key}
          placement="topLeft"
          mouseEnterDelay={0.8}
          mouseLeaveDelay={0}
          title={item.name}
          classNames={{ root: 'aurora-tooltip' }}
          className={item.category === DESIGN_FAILED ? 'rocky-debug-tooltip-span'
            : item.category === DESIGN_IDENTIFY_FAILED ? 'rocky-warning-tooltip-span' : 'rocky-tooltip-span'}
        >{item.name}
        </Tooltip>

        <Fragment>
          {item.category === DESIGN_FAILED &&
            <Tooltip title="Design upload failed" classNames={{ root: 'aurora-tooltip aurora-error-tooltip' }}>
              <ExclamationCircleOutlined className="debug-design-icon" />
            </Tooltip>
          }
          {item.category === DESIGN_IDENTIFY_FAILED &&
            <Tooltip title="Interface identification failed " classNames={{ root: 'aurora-tooltip aurora-warning-tooltip' }}>
              <ExclamationCircleOutlined className="identify-failed-design-icon " />
            </Tooltip>
          }
        </Fragment>
        <Fragment>{Keys.map((key, index) => { return getIcon(key, item) })}</Fragment>
      </span>
    );
  }
  if (item.dataType === MY_TRASH) {
    return <span>
      <span>{`${item.name} - ${item.ddrType}`}</span>
      <Fragment>{Keys.map((key, index) => { return getIcon(key, item) })}</Fragment>
    </span>
  }
  // !!! Can not delete the item.key className, item.key used for aurora-rocky-puppeteer - (channel-521048035883618304), open byte setup page
  return <span>
    <Tooltip
      key={item.key}
      placement="topLeft"
      mouseEnterDelay={0.8}
      mouseLeaveDelay={0}
      title={item.name}
      className={`rocky-tooltip-span ${item.key}` + (item.dataType === CARD_RESULT ? ' rocky-card-result' : '')}
      classNames={{ root: 'aurora-tooltip' }}
    >{item.name}
    </Tooltip>
    {
      defaultDecap && defaultDecap.libraryId && item.id === defaultDecap.libraryId ?
        <Tag color="#fff" className="rocky-decap-default">Default</Tag> : null
    }
    <Fragment>{Keys.map((key, index) => { return getIcon(key, item) })}</Fragment>
  </span >
}

export { verificationTitle, outTitle, libraryTitle, maskTitle, defaultTitle, IconKey, getIconKey, CREATE_PACKAGE_CHANNEL_LOADING };